import { StarsInfo } from '@ps/web-shared-components';
import React from 'react';

import AMLButtonGroup from '@swf/components/AMLButtonGroup/AMLButtonGroup';
import Translation from '@swf/components/Translation/Translation';
import SoftDeadlineIcon from '@swf/core/assets/icons/info.svg';
import { DocumentType } from '@swf/core/enums';
import useWizardExit from '@swf/core/hooks/useWizardExit';

import CTAButton from '../../../../../CTAButton/CTAButton';
import useRmfLogout from '../../../../hooks/useRmfLogout';

import {
  TXTCLI_Upload_My_DriverXs_License,
  TXTCLI_Upload_My_National_ID_Card,
  TXTCLI_Upload_My_Passport,
  TXTWCL_Just_so_you_know,
  TXTWCL_Select_a_photo_ID_to_upload,
  TXTWCL_Upload,
  TXTWCL_Upload_Later,
  TXTWCL_Verifying_your_account_helps_u_ELL
} from './Verification.messages.json';
import { buttons, info, infoHeader } from './Verification.scss';

const uploadDocumentButtonText = {
  [DocumentType.Passport]: TXTCLI_Upload_My_Passport,
  [DocumentType.DrivingLicense]: TXTCLI_Upload_My_DriverXs_License,
  [DocumentType.NationalIDCard]: TXTCLI_Upload_My_National_ID_Card
};

interface Props {
  handleClick(): void;
}

const Verification: React.FC<Props> = ({ handleClick }) => {
  const exitWizard = useWizardExit();
  const logout = useRmfLogout();
  const handleUploadLaterClick = () => {
    exitWizard();
    logout?.();
  };

  return (
    <>
      <StarsInfo className={info}>
        <div className={infoHeader}>
          <SoftDeadlineIcon width="22" height="20" />
          <Translation tagName="b" {...TXTWCL_Just_so_you_know} />
        </div>
        <Translation {...TXTWCL_Verifying_your_account_helps_u_ELL} />
      </StarsInfo>
      <Translation tagName="p" {...TXTWCL_Select_a_photo_ID_to_upload} />
      <AMLButtonGroup small>
        {(documentType) => (
          <div className={buttons}>
            {documentType !== undefined ? (
              <CTAButton
                type="button"
                onClick={handleClick}
                translation={uploadDocumentButtonText[documentType]}
              />
            ) : (
              <CTAButton disabled type="button" translation={TXTWCL_Upload} />
            )}
            <CTAButton
              type="button"
              variant="secondary"
              translation={TXTWCL_Upload_Later}
              onClick={handleUploadLaterClick}
            />
          </div>
        )}
      </AMLButtonGroup>
    </>
  );
};

export default Verification;
